<script setup lang="ts">
import { CREDIT_HOW_IT_WORKS } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';
</script>

<template>
	<section class="bg-black px-5 py-20 text-[#FAFAFA] lg:px-6 lg:py-36">
		<div class="mx-auto max-w-[1240px]">
			<CreditSectionTitle>Como funciona</CreditSectionTitle>
			<ol class="m-0 mt-10 grid list-none p-0 lg:mt-19 lg:grid-cols-4 lg:gap-8">
				<li
					v-for="(item, index) in CREDIT_HOW_IT_WORKS"
					:key="item.number"
					class="relative grid grid-cols-[48px_1fr] gap-x-5 pb-10 last:pb-0 lg:block lg:pb-0"
				>
					<span
						v-if="index < CREDIT_HOW_IT_WORKS.length - 1"
						aria-hidden="true"
						class="absolute top-14 bottom-2 left-6 w-px bg-[#2A2A2A] lg:top-6 lg:right-0 lg:bottom-auto lg:left-16 lg:h-px lg:w-auto"
					/>
					<span
						class="row-span-2 flex size-12 items-center justify-center bg-beige text-[18px] text-black"
					>
						{{ item.number }}
					</span>
					<h3
						class="m-0 flex min-h-12 items-center text-[18px] font-medium lg:mt-7 lg:block lg:min-h-0"
					>
						{{ item.title }}
					</h3>
					<p class="m-0 mt-1 text-[16px] leading-[1.5] text-[#A3A3A3] lg:mt-3">
						{{ item.description }}
					</p>
				</li>
			</ol>
		</div>
	</section>
</template>
